import { render, staticRenderFns } from "./CardMascarasOfertas.vue?vue&type=template&id=29a8c8bc&scoped=true&"
import script from "./CardMascarasOfertas.vue?vue&type=script&lang=js&"
export * from "./CardMascarasOfertas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a8c8bc",
  null
  
)

export default component.exports